/* eslint-disable max-classes-per-file */
import { AnswerModel } from 'core/models/elements/answers/answer.abstract.model';

import { pascalToCamel } from 'utils/common.util';

/**
 * @class Defines an associate answer corresponding to an associate question.
 */
export class AssociateQuestionAnswerModel extends AnswerModel {
  /**
   * @constructor Creates an instance of an associate answer built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.rIds = bo.rIds;
  }

  static instantiateFromApi(data) {
    const bo = pascalToCamel(data);
    return new AssociateQuestionAnswerModel(bo);
  }
}
